var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isMapOfValuesByFieldName, isPrimitiveArrayValue, isPrimitiveArrayOptions, isStringOption, } from './selectTypes';
export var buildSelectValueNoneSelected = function (inputOptions, multiple) {
    if (multiple === void 0) { multiple = false; }
    if (isPrimitiveArrayOptions(inputOptions)) {
        return multiple ? [] : null;
    }
    return {};
};
export var buildSelectValueAllSelected = function (inputOptions) {
    if (isPrimitiveArrayOptions(inputOptions)) {
        return inputOptions;
    }
    return buildAllValuesByFieldName(inputOptions);
};
var buildAllValuesByFieldName = function (inputOptions) {
    var rootOption = ensureObjectOptions(inputOptions);
    var fieldNames = rootOption.fieldNames, options = rootOption.options;
    var outputMap = {};
    fillAllValuesByFieldNameFromOptions(outputMap, options, fieldNames);
    return outputMap;
};
var fillAllValuesByFieldNameFromOptions = function (outputMap, options, parentFieldNames) {
    options.forEach(function (option) {
        if (isStringOption(option)) {
            return addValueForFieldNames(outputMap, option, parentFieldNames);
        }
        var optionFieldNames = option.fieldNames, subOptions = option.options;
        var fieldNames = optionFieldNames || parentFieldNames;
        fillAllValuesByFieldNameFromOptions(outputMap, subOptions, fieldNames);
    });
};
var addValueForFieldNames = function (map, value, fieldNames) {
    fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.forEach(function (fieldName) { return addValueForFieldName(map, value, fieldName); });
};
var addValueForFieldName = function (map, value, fieldName) {
    if (!map[fieldName]) {
        map[fieldName] = [];
    }
    map[fieldName].push(value);
};
export var buildValueAfterSelectingOption = function (currentValue, optionValue, fieldNames) {
    if (isMapOfValuesByFieldName(currentValue)) {
        if (!Array.isArray(fieldNames) || fieldNames.length === 0) {
            return currentValue;
        }
        var newValues_1 = __assign({}, currentValue);
        fieldNames.forEach(function (fieldName) {
            var prevValues = currentValue[fieldName];
            newValues_1[fieldName] = Array.isArray(prevValues) ? addValueToArray(prevValues, optionValue) : [optionValue];
        });
        return newValues_1;
    }
    if (isPrimitiveArrayValue(currentValue)) {
        return addValueToArray(currentValue, optionValue);
    }
    return optionValue;
};
var addValueToArray = function (values, item) {
    if (values.indexOf(item) > -1) {
        return values;
    }
    return __spreadArray(__spreadArray([], values, true), [item], false);
};
export var buildValueAfterDeselectingOption = function (currentValue, optionValue, fieldNames) {
    if (isMapOfValuesByFieldName(currentValue)) {
        if (!Array.isArray(fieldNames) || fieldNames.length === 0) {
            return currentValue;
        }
        var newValues_2 = __assign({}, currentValue);
        fieldNames.forEach(function (fieldName) {
            var prevValues = currentValue[fieldName];
            newValues_2[fieldName] = Array.isArray(prevValues) ? removeValueFromArray(prevValues, optionValue) : [];
        });
        return newValues_2;
    }
    if (isPrimitiveArrayValue(currentValue)) {
        return removeValueFromArray(currentValue, optionValue);
    }
    return null;
};
var removeValueFromArray = function (values, item) {
    return values.filter(function (val) { return val !== item; });
};
export var ensureObjectOptions = function (options) {
    if (isPrimitiveArrayOptions(options)) {
        return {
            options: __spreadArray([], options, true),
        };
    }
    return options;
};
export var isOptionSelected = function (currentValue, optionValue, fieldNames) {
    if (currentValue === null) {
        return false;
    }
    if (isMapOfValuesByFieldName(currentValue)) {
        if (!Array.isArray(fieldNames) || fieldNames.length === 0) {
            console.error('Inconsistent parameters, got an object value for Select element, without providing required fieldNames ' +
                'in the options. The options might not behave correctly, or might not appear selected.');
            return false;
        }
        var fieldName = fieldNames[0];
        var values = currentValue[fieldName];
        return values ? values.indexOf(optionValue) !== -1 : false;
    }
    if (isPrimitiveArrayValue(currentValue)) {
        return currentValue.indexOf(optionValue) !== -1;
    }
    // primitive type
    return currentValue === optionValue;
};
